/**
 * This file is part of ONP.
 *
 * Copyright (c) Opensoft (http://opensoftdev.com)
 *
 * The unauthorized use of this code outside the boundaries of
 * Opensoft is prohibited.
 *
 * @author Ivetta Tkachenko <ivetta.tkachenko@opensoftdev.ru>
 */

define(['underscore', 'backbone', 'assets/js/modules/widgets/gallery/model/templateModel', 'assets/js/modules/api/template'], function(
    _,
    backbone,
    TemplateModel,
    templateApi
) {
    function Gallery(model) {
        var _this = this;

        this.model = model;
        _.extend(this, backbone.Events);

        this.listenTo(this.model, {
            'change:product': function() {
                _this.reloadProductTemplates();
            },
            'change:templates': function() {
                _this.model.trigger('Gallery:changeTemplates');
            },
            'choose:template': function(id) {
                _this.chooseTemplate(id);
            },
            search: function(searchContext) {
                _this.searchTemplates(searchContext);
            },
            loadPage: function(page) {
                _this.getProductTemplatesByPage(page);
            }
        });
    }

    Gallery.prototype = {
        reloadProductTemplates: function() {
            var _this = this;
            _this.model.set('galleryLoading', true);
            _this.model.set('page', 1);
            templateApi
                .getProductTemplates()
                .once('success', function(data) {
                    _this.model.set('page', data.page);
                    _this.model.set('total', data.total);
                    _this.setProductTemplates(data._embedded.items);
                })
                .once('error', function() {
                    _this.model.trigger('templateApi:get:error');
                })
                .once('finished', function() {
                    _this.model.set('galleryLoading', false);
                })
                .start(
                    _.extend(
                        {
                            slug: _this.model.get('product').get('slug'),
                            page: _this.model.get('page'),
                            limit: _this.model.get('limit')
                        },
                        _this.model.get('searchContext')
                    )
                );
        },

        /**
         * @param {number} page
         */
        getProductTemplatesByPage: function(page) {
            var _this = this;
            this.model.set('templatesLoading', true);
            templateApi
                .getProductTemplates()
                .once('success', function(data) {
                    _this.model.set('page', data.page);
                    _this.model.set('total', data.total);
                    _this.addProductTemplates(data._embedded.items);
                })
                .once('finished', function() {
                    _this.model.set('templatesLoading', false);
                })
                .start(
                    _.extend(
                        {
                            slug: _this.model.get('product').get('slug'),
                            page: page,
                            limit: _this.model.get('limit')
                        },
                        _this.model.get('searchContext')
                    )
                );
        },

        /**
         * @param {Object} searchContext
         */
        searchTemplates: function(searchContext) {
            if (!searchContext.name) {
                searchContext = null;
            }
            this.model.set('searchContext', searchContext);
            this.reloadProductTemplates();
        },

        /**
         * @param {Object} templatesDTO
         */
        setProductTemplates: function(templatesDTO) {
            var templates = new backbone.Collection();
            _.each(templatesDTO, function(templateDTO) {
                templates.add(new TemplateModel().fromDTO(templateDTO));
            });
            this.model.set('templates', templates);
        },

        /**
         * @param {Object} templatesDTO
         */
        addProductTemplates: function(templatesDTO) {
            var templates = [];
            _.each(templatesDTO, function(templateDTO) {
                templates.push(new TemplateModel().fromDTO(templateDTO));
            });
            this.model.get('templates').add(templates);
            this.model.trigger('templates:add', templates);
        },

        /**
         * @param {number} id
         */
        chooseTemplate: function(id) {
            var template = this.model.get('templates').get(id);
            if (template) {
                this.model.trigger('Gallery:chooseTemplate', template);
            }
        }
    };

    return Gallery;
});
